
export enum enumHotCardIDType {
  'RSA ID' = 1,
  Passport,
  'Date of Birth',
  'Namibia ID',
  Business,
  Other
}

export namespace enumHotCardIDType {
  export function values() {
    return Object.keys(enumHotCardIDType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
